/*
 * View for response translation tasks (modal)
 */

define(["marionette", "./template/reviewerTranslationModalTemplate.html"], function (
  Marionette,
  ReviewerTranslationModalTemplate,
) {
  const ReviewerTranslationModalView = {};

  ReviewerTranslationModalView.reviewerTranslationModalView = Marionette.Layout.extend({
    template: ReviewerTranslationModalTemplate,
    regions: {
      htmlEditor: ".html-editor",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return ReviewerTranslationModalView;
});
